<div id="orManagingCompanyUsers">

  @if (managingCompany) {
    <div class="w-1/2 mx-auto text-center mt-5 mb-12">
      <div class="text-sm tracking-widest text-gray-500 mb-2">
        MANAGING COMPANY USERS FOR
      </div>
      <div class="text-5xl font-extrabold text-gray-800 uppercase">
        {{ managingCompany.companyName }}
      </div>
    </div>
  }

  <app-managing-company-users-filters
  [buildings]="buildings"
  [dialogBuildings]="allMcBuildings"
  [showUnassigned]="hasUnassigned"
  [managingCompanyId]="managingCompany?.id"
  (buildingsSelected)="onBuildingsSelected($event)"
  (userSearchChanged)="onUserSearchChanged($event)"
  (addOrUpdateExistingUser)="onAddFromExistingUsers($event)">
  </app-managing-company-users-filters>

  @if (loading) {
    <div class="spinner-container">
      <mat-spinner class="mx-auto" mode="indeterminate"></mat-spinner>
    </div>
  } @else {
    <app-managing-company-users-table
      [buildingUsers]="filteredBuildingUsers"
      [managingCompanyId]="managingCompany?.id"
      (editRequested)="onEditUser($event)"
      (deleteRequested)="onDeleteUserFromBuilding($event)">
    </app-managing-company-users-table>
  }
</div>
